import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output, input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Capacitor } from '@capacitor/core';
import { CodaltComponent } from '../../codalt.component';
import { CustomerProjectPhase } from '../../customer-project-phase.interface';
import { CustomerProject } from '../../customer-project.interface';
import { CustomerProjectPhaseService } from '../../services/customer-project/customer-project-phase.service';
import { CustomerProjectPhaseEditDialogComponent } from './customer-project-phase-edit-dialog/customer-project-phase-edit-dialog.component';

@Component({
    selector: 'app-customer-project-phase-list',
    templateUrl: './customer-project-phase-list.component.html',
    styleUrls: ['./customer-project-phase-list.component.scss'],
    standalone: false,
})
export class CustomerProjectPhaseListComponent extends CodaltComponent implements OnInit {
    @Output()
    phaseSelected = new EventEmitter<CustomerProjectPhase>();

    @Input()
    project: CustomerProject;

    @Input()
    projectPhases: CustomerProjectPhase[];

    @Input()
    currentProjectPhase: CustomerProjectPhase;

    @Input()
    selectedPhase: CustomerProjectPhase;

    showDonePhases = input(false);

    disableDragDrop = Capacitor.isNativePlatform();

    constructor(
        private dialog: MatDialog,
        private customerProjectPhaseService: CustomerProjectPhaseService
    ) {
        super();
    }

    ngOnInit(): void {
        let phaseToSelect: CustomerProjectPhase;
        if (this.currentProjectPhase && !this.selectedPhase) {
            phaseToSelect = this.projectPhases.find(p => p.id === this.currentProjectPhase.id);
        }
        if (!phaseToSelect && !this.selectedPhase && this.projectPhases?.length > 0) {
            phaseToSelect = this.projectPhases.find(p => this.showDonePhases() || !p.done);
        }
        if (phaseToSelect) {
            setTimeout(() => this.selectPhase(phaseToSelect));
        }
    }

    selectPhase(projectPhase?: CustomerProjectPhase) {
        this.selectedPhase = projectPhase;
        this.phaseSelected.emit(projectPhase);
    }

    drop(event: CdkDragDrop<string[]>, items: any[]) {
        moveItemInArray(items, event.previousIndex, event.currentIndex);
        this.customerProjectPhaseService.updatePhaseOrder(this.projectPhases, this.project.id).subscribe();
    }

    editPhase(projectPhase?: CustomerProjectPhase) {
        if (!projectPhase) {
            projectPhase = {
                customer_project_phase_activities: [],
                customer_project_phase_replies: [],
                customer_project_id: this.project.id,
            } as CustomerProjectPhase;
            if (this.projectPhases) {
                const prevFase = this.projectPhases[this.projectPhases.length - 1];
                if (prevFase?.start_date) {
                    const date = new Date(prevFase.start_date);
                    date.setDate(date.getDate() + 1);
                    projectPhase.start_date = date;
                }
            }
        }
        this.dialog
            .open(CustomerProjectPhaseEditDialogComponent, {
                panelClass: 'confirm-dialog',
                disableClose: true,
                data: projectPhase,
            })
            .afterClosed()
            .subscribe((phase: CustomerProjectPhase | CustomerProject) => {
                if (!phase) {
                    return;
                }
                if ('customer_projectphase_id' in phase) {
                    Object.assign(this.project, phase);
                    this.project.customer_project_phase = this.projectPhases.find(
                        p => p.id === this.project.customer_projectphase_id
                    );
                } else {
                    if (!phase.deleted_at) {
                        if (!this.projectPhases.find(p => p.id === phase.id) && phase) {
                            this.projectPhases.push(phase);
                        }
                    } else {
                        this.projectPhases.splice(this.projectPhases.indexOf(phase), 1);
                    }
                }
            });
    }
}
